import { UseFormRegisterReturn } from 'react-hook-form';
import { Icon } from '../atoms';
import { ErrorBox } from './ErrorBox';
import { Tag } from './Tag';

type TagButton = {
  label: string;
  value: string;
};

type TagSelectProps = {
  tags: TagButton[];
  selectedTags: string[];
  onSelectionChange: (selectedTags: string[]) => void;
  error?: string;

  register: () => UseFormRegisterReturn<string>;

  // When false this becomes a single-select "pill" group.
  multiple?: boolean;
  errorVariant?: 'default' | 'compact';
};

export const TagSelect = (props: TagSelectProps) => {
  const {
    tags,
    onSelectionChange,
    selectedTags,
    error,
    register,
    multiple = true,
    errorVariant = 'default',
  } = props;

  const toggleTag = (tag: string) => {
    if (!multiple) {
      onSelectionChange(selectedTags.includes(tag) ? [] : [tag]);
      return;
    }

    const updatedSelection =
      selectedTags.includes(tag) ? selectedTags.filter((t) => t !== tag) : [...selectedTags, tag];

    onSelectionChange(updatedSelection);
  };

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-row gap-4 flex-wrap' {...register()}>
        {tags.map((tag) => {
          const isSelected = selectedTags.includes(tag.value);
          return (
            <Tag
              size='lg'
              roundedFull={true}
              key={tag.value}
              onClick={() => toggleTag(tag.value)}
              additionalClassNames={
                multiple ?
                  `cursor-pointer text-gray-500 select-none ${isSelected ? 'bg-gray-100' : 'bg-gray-50'}`
                : `cursor-pointer select-none ${isSelected ? 'bg-brand-500 border-brand-500 text-white' : 'bg-gray-50 text-gray-700 hover:border-gray-400'}`
              }
            >
              {tag.label}
            </Tag>
          );
        })}
      </div>
      {error &&
        (errorVariant === 'compact' ?
          <ErrorBox variant='compact' showAlertTriangle>
            {error}
          </ErrorBox>
        : <ErrorBox>
            <div className='w-6 flex items-center justify-center'>
              <Icon type='alert-triangle' size='24' />
            </div>
            {error}
          </ErrorBox>)}
    </div>
  );
};

export default TagSelect;
